import type { AllowedProductProfileEntity } from "src/app/features/AllowedProductProfile/types/AllowedProductProfileEntity";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import { AllowedProductProfileDtoToEntity } from "../mappers/AllowedProductProfileDtoToEntity";
import { AllowedProductProfileEntityToDto } from "../mappers/AllowedProductProfileEntityToDto";

const AllowedProductProfileApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        AllowedProductProfileLoad: builder.query<AllowedProductProfileEntity, FormQuery>({
            providesTags: [ResourceName.ALLOWED_PRODUCT_PROFILES],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.ALLOWED_PRODUCT_PROFILES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return AllowedProductProfileDtoToEntity(response);
            },
        }),
        AllowedProductProfileSave: builder.mutation<AllowedProductProfileEntity, FormMutation<AllowedProductProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.ALLOWED_PRODUCT_PROFILES}`;
                const method = "POST";

                const body = AllowedProductProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.ALLOWED_PRODUCT_PROFILES],
        }),
        AllowedProductProfileUpdate: builder.mutation<AllowedProductProfileEntity, FormMutation<AllowedProductProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.ALLOWED_PRODUCT_PROFILES}/${mutation.data.id}`;
                const method = "PUT";

                const body = AllowedProductProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.ALLOWED_PRODUCT_PROFILES],
        }),
    }),
});

export const { useAllowedProductProfileLoadQuery, useAllowedProductProfileSaveMutation, useAllowedProductProfileUpdateMutation } =
    AllowedProductProfileApi;
